import React from 'react';
import { Container, Row, Col,Card , CardHeader,CardBody,FormInput,Button,Form } from "shards-react";
import PageTitle from "../common/PageTitle";
import firebase from '../../firebase';
import { AtomSpinner } from 'react-epic-spinners';
import alert from '../AlertStore';
import {Link} from 'react-router-dom';



export default class ChangeAuctionTimings extends React.Component{
  constructor(props) {
    super(props);
  
    this.state = {	loading  :false,
            		group_id : null,
            		prev_timings : null,
            		auct_id  : null,
            		new_timings : null,
            };
    this.changeAuctTimings = this.changeAuctTimings.bind(this);
  }


  componentDidMount(){
      var url_string = window.location.href;
      var url = new URL(url_string);
      var group_id = url.searchParams.get("group_id");
      var prev_timings =url.searchParams.get('prev_timings');
      var auct_id = url.searchParams.get('auct_id');


      this.setState({
            group_id,
            prev_timings,
            auct_id,
      });
  }

  changeAuctTimings = () =>{
  		if(this.state.new_timings===null || this.state.new_timings===undefined){
  			alert.showMessage("Kindly Enter New Timings","warning");
  			return;
  		}
  		if(this.state.auct_id===null || this.state.auct_id===undefined  || this.state.prev_timings===undefined || this.state.prev_timings===null ){
  			alert.showMessage("Error : A Required Parameter is Missing","warning");
  			return;
  		}

  		var data = {
  			auct_id : this.state.auct_id,
  			prev_timings : new Date(this.state.prev_timings).toUTCString(),
  			new_timings : this.state.new_timings.toUTCString(),
  		}

  		var that = this;

  		this.setState({loading:true});

		var func_ref = firebase.functions().httpsCallable('ChangeAuctionTimings');

		func_ref(data).then(function(result) {
                  // Read result of the Cloud Function.
                  var data = result.data;
                  console.log(data);
                  if(data.status==="success"){
                        console.log("Document succesfully added!");
                        alert.showMessage("Timings Changeed Succesfully Added Successfully","success");
                        window.close();
                   }
                  else{
                        console.log(data.message);
                        alert.showMessage(data.message,"error");
                  }
                  that.setState({loading:false});

        }).catch(function(error) {
                  // Getting the Error details.
                  //var code = error.code;
                  //var message = error.message;
                  //var details = error.details;
                  // ...
                  console.log(error);
                  that.setState({loading:false});
                  alert.showMessage("Unable to Change Timings","error");
        });



  }

 

  render(){


    return(
       <Container fluid className="main-content-container px-4 pb-4">
          
            {/* Page Header */}
            <Row noGutters className="page-header py-4">
                  <PageTitle sm="4" title="Change Timings" subtitle="Auction" className="text-sm-left" />
            </Row>

            <Link to="/auction" style={{marginBottom: '2%',marginLeft: '2%'}}>
                <Button type="submit" theme="danger">Cancel</Button>
           </Link>


          <Col lg="12">
               <Card small className="mb-4">
                    <CardHeader className="border-bottom">
                          <h6 className="m-0">Change Auction Timings</h6>
                    </CardHeader>
                    <CardBody className="p-2 pb-2" >
                      {
                        !this.state.loading &&
                        <Col>
                          <Form /*onSubmit={this.onSubmitHandler}*/>
                            <Row form>
                              <FormTextInput size="4" type="text" field_name="Group ID" disabled value={this.state.group_id} onChange={()=>{}}/>   
                              <FormTextInput size="8" type="text" field_name="Previous Timings" disabled value={this.state.prev_timings} onChange={()=>{}} />
                            </Row>
                            <Row form>
                             	<FormTextInput size="4" type="datetime-local" field_name="New Timings" onChange={(evt)=>{this.setState({new_timings:new Date(evt.target.value)})}}/>   
                            
                            </Row>
                          

                              <SubmitButton onClick={this.changeAuctTimings} />
                              
                          </Form>
                        </Col>
                      }
                      
                        {
                          (this.state.loading) &&
                          <AtomSpinner color="blue" style={{alignSelf: 'center',marginLeft: '40%',marginTop: '10%',marginBottom: '10%'}}/>
                        }
                      
                    </CardBody>
                </Card>
              </Col>


        </Container>

    )
  }
}


class SubmitButton extends React.Component{
  render(){
    return(
      <Row>
                            <Col lg="4"></Col>
                                <Col lg="4">
                                  <Button onClick={this.props.onClick} style={{maxWidth: '100%',width:'100%',marginTop: '1%'}} size="md">
                                    {"Change Timings"}
                                  </Button>
                                </Col>
                                <Col lg="4"></Col>
                            </Row>

    )
  }
}

//dont use for date
class FormTextInput extends React.Component{
  render(){
    return(
       <Col md={this.props.size} className="form-group">
                  <label>{this.props.field_name}</label>
                  <FormInput
                  {...this.props}
                  type={this.props.type}
                  placeholder={this.props.field_name}
                  onChange = {this.props.onChange}
                />

              </Col>
    )
  }
}

